// Styles for React Select Fields
const SelectCustomStyles: any = {
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: "white",
    border: state.isFocused ? "1px solid #FA7268" : null,
    boxShadow: state.isFocused ? 0 : 0,
    ":hover": {
      border: "1px solid #FA7268",
    },
  }),

  option: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#FA7268" : isFocused ? "#FFB7B1" : null,
      color: isSelected ? "#fff" : "#111",

      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled && (isSelected ? data.color : "#FFB7B1"),
      },
    };
  },
  multiValue: (styles: any) => {
    return {
      ...styles,
      backgroundColor: "#FA7268",
    };
  },
  multiValueLabel: (styles: any) => ({
    ...styles,
    color: "#fff",
  }),
  multiValueRemove: (styles: any) => ({
    ...styles,
    color: "#fff",
    ":hover": {
      backgroundColor: "#01254B",
    },
  }),
};

export default SelectCustomStyles;
